import { render, staticRenderFns } from "./storedvalue.vue?vue&type=template&id=65220b01"
import script from "./storedvalue.vue?vue&type=script&lang=js"
export * from "./storedvalue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports